export default "__VITE_ASSET__2208f399__"